import React from 'react';

import PropTypes from 'prop-types';

import { FormGroup } from 'reactstrap';

import { connect } from 'react-redux';

import { Field, Form, reduxForm } from 'redux-form';

import FormItem from '../../../common/forms/FormItem';

import TextInput from '../../../common/forms/input/TextInput';

import BankAccountSelect from '../../../common/forms/select/BankAccountSelect';

import DatePicker from '../../../common/forms/input/DatePicker';

import FormFooter from '../../../common/forms/FormFooter';

import { isRequired, validateNumber } from '../../../../utils/validators';

const FORM_NAME = 'ManualVoucherPaymentEditForm';

export const ManualVoucherPaymentEditForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <h4>Información del Pago</h4>

    <FormGroup>
      <FormItem label="Cuenta Bancaria" requiredLabel>
        <Field
          name="bankAccountId"
          component={BankAccountSelect}
          validate={[isRequired]}
          cleanWhenUnmount={false}
          isClearable={false}
        />
      </FormItem>
    </FormGroup>

    <FormGroup>
      <FormItem label="Número de Operación" requiredLabel>
        <Field
          name="operationNumber"
          component={TextInput}
          validate={[validateNumber, isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup>
      <FormItem label="Monto depositado" requiredLabel>
        <Field
          name="amount"
          component={TextInput}
          validate={[validateNumber, isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup>
      <FormItem label="Fecha de depósito" requiredLabel>
        <Field
          name="depositDate"
          component={DatePicker}
          validate={[isRequired]}
          time
        />
      </FormItem>
    </FormGroup>

    <FormFooter saveButtonDisabled={loading} />
  </Form>
);

ManualVoucherPaymentEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ManualVoucherPaymentEditForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(ManualVoucherPaymentEditForm);

export default connect(mapStateToProps)(formComponent);
